export default __webpack_public_path__ + "static/media/icon_category-reconstrucion.da367297.svg";